import React from 'react';

import logo from 'images/logo_white.svg';
import { colors, fonts, footerHeight } from 'components/variables';
// Icons temporarily omitted

const year = new Date().getFullYear();

const footerStyle = {
	background: colors.blue.brommaDarkest,
	color: '#c9c9c9',
	padding: '32px 42px',
	height: footerHeight,
	position: 'relative',
	width: '100%',
	left: 0,
	right: 0,
	zIndex: 1000,
	marginTop: '120px',
};

const innerStyle = {
	height: '100%',
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'space-between',
};

const brandRowStyle = {
	display: 'flex',
	alignItems: 'center',
};

const linksStyle = {
	display: 'flex',
};

const linkStyle = {
	color: '#c9c9c9',
	textDecoration: 'none',
	fontFamily: fonts.primary,
	fontSize: 14,
};

const copyrightStyle = {
	color: '#c9c9c9',
	fontSize: 14,
	fontFamily: fonts.primary,
};

const brandStyle = {
	display: 'flex',
	alignItems: 'center',
	gap: 12,
};

const bottomRowStyle = {
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
};

const leftGroupStyle = {
	display: 'flex',
};

const spacer24 = { marginLeft: 24 };

const Footer = () => (
	<footer style={footerStyle} className="site-footer">
		<div style={innerStyle} className="footer-inner">
			<div style={brandRowStyle}>
				<div style={brandStyle}>
					<img src={logo} alt="Bromma" style={{ height: 30 }} />
				</div>
			</div>

			<div style={bottomRowStyle} className="footer-bottom">
				<div style={leftGroupStyle} className="footer-left">
					<nav
						aria-label="footer links"
						style={linksStyle}
						className="footer-links"
					>
						<a
							href="https://bromma.com/privacy-policy/"
							style={linkStyle}
							target="_blank"
							rel="noopener noreferrer"
						>
							Privacy Policy
						</a>
						<a
							href="https://bromma.com/legal-notice/"
							style={{ ...linkStyle, ...spacer24 }}
							target="_blank"
							rel="noopener noreferrer"
						>
							Legal Notice
						</a>
					</nav>
					<div
						style={{ ...copyrightStyle, ...spacer24 }}
						className="footer-copyright"
					>
						© {year} Bromma. All Rights Reserved
					</div>
				</div>
			</div>
		</div>
	</footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js